import {
  FIELD_NAME_AMOUNT,
  FIELD_NAME_INSTRUMENT_ID,
  FIELD_NAME_ORDER_FREQUENCY,
  FIELD_NAME_QUANTITY,
  FIELD_NAME_QUANTITY_LIMIT,
  FIELD_NAME_RATE_LIMIT,
  FIELD_NAME_SIDE,
  FIELD_NAME_STATUS,
} from '../../constants/swapReinvestment';
import {
  SR_GET_USER_SETTINGS_SUCCESS,
  SR_POST_USER_SETTING_SUCCESS,
  SR_PATCH_USER_SETTING_SUCCESS,
  SR_PATCH_USER_STATUS_SUCCESS,
  SR_RESET_USER_INPUT,
  SR_USER_SETTINGS_LOADING,
  SR_CHANGE_INPUT_VALUE,
  SR_ADD_INPUT_ERROR,
  SR_REMOVE_INPUT_ERROR,
  SR_RESET_INPUT_ERROR,
} from '../actionConstants/swapReinvestmentConstants';

const initialState = {
  userSettings: [],
  //   userSettings: [
  //     {
  //       status: true,
  //       instrumentId: 'NZD_M/USD',
  //       side: '1',
  //       quantity: 1000.0,
  //       amount: null,
  //       orderFrequency: '1',
  //       rateLimit: 160.5,
  //       quantityLimit: 100000.0,
  //       availableAmount: 20000,
  //       updateTime: '2026-01-01 10:18:11',
  //     },
  //     {
  //       status: true,
  //       instrumentId: 'USD/JPY',
  //       side: '3',
  //       quantity: 1000.0,
  //       amount: null,
  //       orderFrequency: '1',
  //       rateLimit: 160.5,
  //       quantityLimit: 100000.0,
  //       availableAmount: 20000,
  //       updateTime: '2026-01-01 10:18:11',
  //     },
  //   ],
  isLoadingUserSettings: false,

  input: {
    status: true,
    instrumentId: null,
    side: null,
    quantity: null,
    amount: null,
    orderFrequency: null,
    rateLimit: null,
    quantityLimit: null,
    errors: [],
  },
  isProcessing: false,
};

const mergePartial = (userSettings = [], partial) => {
  const { instrumentId, side } = partial || {};
  if (!instrumentId || !side) {
    return userSettings;
  }
  const found = userSettings.find((item) => item.instrumentId === instrumentId && item.side === side);
  if (found) {
    return userSettings.reduce((acc, item) => {
      if (item.instrumentId === instrumentId && item.side === side) {
        const newItem = { ...item, ...partial };
        return [...acc, newItem];
      }
      return [...acc, item];
    }, []);
  }
  return [...userSettings, partial];
};

const checkFieldName = (name) => {
  switch (name) {
    case FIELD_NAME_STATUS:
    case FIELD_NAME_INSTRUMENT_ID:
    case FIELD_NAME_SIDE:
    case FIELD_NAME_QUANTITY:
    case FIELD_NAME_AMOUNT:
    case FIELD_NAME_ORDER_FREQUENCY:
    case FIELD_NAME_RATE_LIMIT:
    case FIELD_NAME_QUANTITY_LIMIT:
      return true;
    default:
      return false;
  }
};

export const swapReinvestment = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SR_GET_USER_SETTINGS_SUCCESS: {
      const { userSettings = [] } = payload || {};
      return {
        ...state,
        userSettings,
      };
    }
    case SR_POST_USER_SETTING_SUCCESS:
    case SR_PATCH_USER_SETTING_SUCCESS:
    case SR_PATCH_USER_STATUS_SUCCESS: {
      const { userSetting: partial = {} } = payload || {};
      const userSettings = mergePartial(state.userSettings, partial);
      return {
        ...state,
        userSettings,
      };
    }
    case SR_RESET_USER_INPUT: {
      const { input } = payload || {};
      const { status, instrumentId, side, quantity, amount, orderFrequency, rateLimit, quantityLimit } =
        input || initialState.input;
      return {
        ...state,
        input: {
          status,
          instrumentId,
          side,
          quantity,
          amount,
          orderFrequency,
          rateLimit,
          quantityLimit,
          errors: [],
        },
      };
    }
    case SR_USER_SETTINGS_LOADING: {
      const { loading: isLoadingUserSettings = false } = payload || {};
      return {
        ...state,
        isLoadingUserSettings,
      };
    }
    case SR_CHANGE_INPUT_VALUE: {
      const { name, value } = payload || {};
      if (checkFieldName(name)) {
        return {
          ...state,
          input: { ...state.input, [name]: value },
        };
      }
      return state;
    }
    case SR_ADD_INPUT_ERROR: {
      const { name, error } = payload || {};
      if (checkFieldName(name)) {
        return {
          ...state,
          error: [...state.error, error],
        };
      }
      return state;
    }
    case SR_REMOVE_INPUT_ERROR: {
      const { name, error } = payload || {};
      if (checkFieldName(name)) {
        return {
          ...state,
          error: state.error.filter((e) => {
            if (e.name === name) {
              if (error && e.error === error) {
                return false;
              }
              if (!error) {
                return false;
              }
            }
            return true;
          }),
        };
      }
      return state;
    }
    case SR_RESET_INPUT_ERROR: {
      return {
        ...state,
        error: [],
      };
    }
    default: {
      return state;
    }
  }
};
